import {
  motion, useTransform, useScroll, useSpring
} from 'framer-motion';
import { AnalyticsConsumer } from 'contexts/AnalyticsProvider';
import { DialogConsumer } from 'contexts/DialogProvider';
import { useTheme } from '@mui/material/styles';
import {
  TRACK_EMAIL_CAPTURE_TOGGLED, PATH_FAQ_SHIPPING, PATH_DEAL
} from 'constants';
import Carousel from 'react-material-ui-carousel';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from 'next/link';
import React, { useRef } from 'react';
import makeClasses from 'hooks/useClasses';
import PropTypes from 'prop-types';
import styles from 'styles/jss/components/bookSizeDialogStyle';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

const PeskySignup = ({ promo }) => {
  const ref = useRef(null);
  // const { track } = AnalyticsConsumer();
  // const { showEmailSignup } = DialogConsumer();
  const classes = makeClasses(styles);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end end']
  });
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const BOX_SIZE = isSmall ? ['100%', 40] : ['100%', 40];

  // const handleClick = () => {
  //   track(TRACK_EMAIL_CAPTURE_TOGGLED);
  //   showEmailSignup(true);
  // };

  const position = useTransform(
    scrollYProgress,
    [0.2, 0.21, 0.9, 1],
    [-BOX_SIZE[1], 0, 0, -BOX_SIZE[1]]
  );
  const positionSpring = useSpring(position, { stiffness: 10, damping: 2, mass: 0.2 });

  return (
    <motion.div
      className={classes.peskySignup}
      style={{
        bottom: positionSpring,
        width: BOX_SIZE[0],
        height: BOX_SIZE[1]
      }}
    >
      <Box className="innerBox">
        <Carousel
          interval={4000}
          className="carousel"
          indicators={false}
        >
          {promo && (
            <Link
              href={PATH_DEAL}
              passHref
            >
              <Button
                variant="text"
                size="large"
                color="white"
                // onClick={handleClick}
                component="a"
              >
                <Typography
                  component="h3"
                >
                  {promo.title}
                  {' - '}
                  {promo.discountPercentageLabel}
                  {' '}
                  off! Use
                  {' '}
                  {promo.promoCode}
                </Typography>
              </Button>
            </Link>
          )}
          <Link
            href={PATH_FAQ_SHIPPING}
            passHref
          >
            <Button
              variant="text"
              size="large"
              color="white"
              // onClick={handleClick}
            >
              <Typography
                component="h3"
              >
                Free Ground Shipping on All Orders
              </Typography>
            </Button>
          </Link>
        </Carousel>
      </Box>
    </motion.div>
  );
};

PeskySignup.defaultProps = {
  promo: null
};

PeskySignup.propTypes = {
  promo: PropTypes.shape()
};

export default PeskySignup;
